import { render, staticRenderFns } from "./ClientsLogs.vue?vue&type=template&id=3ee8e337"
import script from "./ClientsLogs.vue?vue&type=script&lang=js"
export * from "./ClientsLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports